import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { games } from "../data/games";
import GameCard from "./GameCard";

const Catalog = ({ t, lang }) => (
  <section id="giochi" data-testid="catalog-section" className="relative py-28 md:py-40 px-6 md:px-12">
    <div
      aria-hidden="true"
      className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-[#D000FF] opacity-[0.07] blur-[160px]"
    />
    <div className="relative max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 md:mb-24"
      >
        <p className="text-sm font-bold tracking-[0.25em] uppercase text-[#00F0FF] mb-5">
          {t.catalog.overline}
        </p>
        <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl mb-6">
          {t.catalog.title}
        </h2>
        <p className="max-w-xl text-base md:text-lg leading-relaxed text-white/60">
          {t.catalog.subtitle}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-5xl">
        {games.map((game, i) => (
          <Link
            key={game.id}
            to={`/giochi/${game.slug}`}
            data-testid={`game-card-link-${game.id}`}
            aria-label={`${game.name} — ${game.tagline[lang]}`}
            className="block rounded-3xl"
          >
            <GameCard game={game} t={t} lang={lang} index={i} />
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default Catalog;
